import { onCLS, onINP, onLCP, onTTFB, onFCP } from 'web-vitals';
import { debug } from './logger.js';

/**
 * Web Vitals Thresholds
 * Source: https://web.dev/vitals/
 */
const THRESHOLDS = {
  CLS: { good: 0.1, needsImprovement: 0.25 },
  INP: { good: 200, needsImprovement: 500 }, // Replaces FID
  LCP: { good: 2500, needsImprovement: 4000 },
  FCP: { good: 1800, needsImprovement: 3000 },
  TTFB: { good: 800, needsImprovement: 1800 }
};

function getRating(name, value) {
  const threshold = THRESHOLDS[name];
  if (!threshold) return 'unknown';

  if (value <= threshold.good) return 'good';
  if (value <= threshold.needsImprovement) return 'needs-improvement';
  return 'poor';
}

function logMetric(metric) {
  const { name, value, id, delta } = metric;
  const rating = getRating(name, value);

  const styles = {
    good: 'color: #0cce6b; font-weight: bold',
    'needs-improvement': 'color: #ffa400; font-weight: bold',
    poor: 'color: #ff4e42; font-weight: bold',
    unknown: 'color: gray'
  };

  console.groupCollapsed(`%cWeb Vitals: ${name} (${rating})`, styles[rating] || styles.unknown);
  debug(`Value: ${Math.round(value * 100) / 100}`);
  debug(`Delta: ${Math.round(delta * 100) / 100}`);
  debug(`ID: ${id}`);
  debug(metric);
  console.groupEnd();

  // You could send 'poor' ratings to an analytics endpoint here
  if (rating === 'poor') {
    console.warn(`[Performance] ${name} is poor! Value: ${value}`);
  }
}

export function reportWebVitals() {
  if (import.meta.env.VITE_ENABLE_WEB_VITALS !== 'true') return;

  onCLS(logMetric);
  onINP(logMetric); // Using INP instead of FID (new standard)
  onLCP(logMetric);
  onFCP(logMetric);
  onTTFB(logMetric);
}